import { useEffect, useState } from "react";
import { AppBar } from "../components/AppBar";
import { SearchDialog } from "../components/SearchDialog";
import { Footer } from "../components/Footer";
import { Hero } from "../sections/Hero";
import { About } from "../sections/About";
import { Experience } from "../sections/Experience";
import { Projects } from "../sections/Projects";
import { Engineering } from "../sections/Engineering";
import { Resume } from "../sections/Resume";
import { Publications } from "../sections/Publications";
import { Talks } from "../sections/Talks";
import { Awards } from "../sections/Awards";
import { Writing } from "../sections/Writing";
import { Reading } from "../sections/Reading";
import { Contact } from "../sections/Contact";
import { useTheme } from "../hooks/useTheme";
import { useRevealOnScroll } from "../hooks/useRevealOnScroll";

export function Portfolio() {
  const [theme, toggleTheme] = useTheme();
  const [searchOpen, setSearchOpen] = useState(false);

  useRevealOnScroll();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "/" && document.activeElement?.tagName !== "INPUT" && !searchOpen) {
        e.preventDefault();
        setSearchOpen(true);
      }
      // ⌘+K / Ctrl+K opens search too
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [searchOpen]);

  return (
    <>
      <AppBar theme={theme} onToggleTheme={toggleTheme} onOpenSearch={() => setSearchOpen(true)} />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Engineering />
        <Resume />
        <Publications />
        <Talks />
        <Awards />
        <Writing />
        <Reading />
        <Contact />
      </main>
      <Footer />

      <SearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}
